import { render, staticRenderFns } from "./MonthlyReports.vue?vue&type=template&id=3bf83a58&scoped=true"
import script from "./MonthlyReports.vue?vue&type=script&lang=js"
export * from "./MonthlyReports.vue?vue&type=script&lang=js"
import style0 from "./MonthlyReports.vue?vue&type=style&index=0&id=3bf83a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf83a58",
  null
  
)

export default component.exports